import React from 'react';
import ClaimTokenModal from '../Components/ClaimTokenModal';
import ExchangeModal from '../Components/ExchangeModal';
import MaintenanceModal from '../Components/MaintenanceModal';
import RequestClaimTokenSuccessModal from '../Components/RequestClaimTokenSuccessModal';
import TransactionSuccessModal from '../Components/TransactionSuccessModal';
import { MainCurrency } from '../config';
var ActionType;

(function (ActionType) {
  ActionType["EXCHANGE"] = "EXCHANGE";
  ActionType["CLAIM"] = "CLAIM";
})(ActionType || (ActionType = {}));

export const WalletContext = /*#__PURE__*/React.createContext({
  startExchange: () => {},
  startClaimToken: () => {},
  openModal: () => {},
  closeModal: () => {},
  showMaintenance: () => {}
});

const WalletProvider = ({
  children
}) => {
  var _ref$current, _ref$current2, _ref$current3;

  const [modal, setModal] = React.useState();
  const ref = React.useRef();
  const openModal = React.useCallback(modalName => {
    setModal(prev => ({ ...prev,
      [modalName]: true
    }));
  }, []);
  const closeModal = React.useCallback(modalName => {
    setModal(prev => ({ ...prev,
      [modalName]: false
    }));
  }, []);
  const startClaimToken = React.useCallback(ingameCoinType => {
    ref.current = { ...ref.current,
      ingameCoinType,
      actionType: ActionType.CLAIM
    };
    openModal('claimToken');
  }, [openModal]);
  const startExchange = React.useCallback(coinType => {
    ref.current = { ...ref.current,
      coinType,
      actionType: ActionType.EXCHANGE
    };
    openModal('exchangeWallet');
  }, [openModal]);
  const showMaintenance = React.useCallback(() => {
    closeModal('claimToken');
    openModal('maintenance');
  }, [openModal]);
  const context = React.useMemo(() => {
    return {
      startExchange,
      startClaimToken,
      modal: modal || undefined,
      openModal,
      closeModal,
      showMaintenance
    };
  }, [closeModal, modal, openModal, startClaimToken, startExchange]);
  return /*#__PURE__*/React.createElement(WalletContext.Provider, {
    value: context
  }, children, (modal === null || modal === void 0 ? void 0 : modal.exchangeWallet) && ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.coinType) && /*#__PURE__*/React.createElement(ExchangeModal, {
    coinType: ref.current.coinType,
    onSuccess: () => {
      openModal('transactionSuccess');
    },
    onClose: () => {
      closeModal('exchangeWallet');
    }
  }), (modal === null || modal === void 0 ? void 0 : modal.claimToken) && ((_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.ingameCoinType) && /*#__PURE__*/React.createElement(ClaimTokenModal, {
    coinType: ref.current.ingameCoinType,
    onSuccess: () => {
      openModal('requestClaimTokenSuccess');
    },
    onClose: () => {
      closeModal('claimToken');
    }
  }), (modal === null || modal === void 0 ? void 0 : modal.transactionSuccess) && ((_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : _ref$current3.coinType) && /*#__PURE__*/React.createElement(TransactionSuccessModal, {
    desc: `Now you can check your Ingame Thetan ${ref.current.coinType === MainCurrency.THETAN_COIN ? 'Coin' : 'Gem'} in Wallet`,
    onClose: () => {
      closeModal('transactionSuccess');
    }
  }), (modal === null || modal === void 0 ? void 0 : modal.requestClaimTokenSuccess) && /*#__PURE__*/React.createElement(RequestClaimTokenSuccessModal, {
    renderDescription: () => {
      return /*#__PURE__*/React.createElement("span", null, "Transaction is processing onchain.", /*#__PURE__*/React.createElement("br", null), "This can take a moment, please be patient.");
    },
    onClose: () => {
      closeModal('requestClaimTokenSuccess');
    }
  }), (modal === null || modal === void 0 ? void 0 : modal.maintenance) && /*#__PURE__*/React.createElement(MaintenanceModal, {
    onClose: () => {
      closeModal('maintenance');
    }
  }));
};

export const useWalletContext = () => {
  const {
    startExchange,
    startClaimToken,
    showMaintenance,
    modal
  } = React.useContext(WalletContext);
  return {
    startExchange,
    startClaimToken,
    showMaintenance,
    modal
  };
};
export default WalletProvider;